import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import 'MagnificPopup';
import * as moment from 'moment';
import { wcagOptions } from "./wcag";

export class feedbackbutton {
	$scope: any = $('.feedback-form--container');

	popup(): any {
		let _self = this;
		let page_name_value=document.title;
		let page_URL_value=$(location).attr('href');
		let OS_value=navigator.platform;
		let Browser_value=navigator.userAgent;
		let Language_value=navigator.language;
		let newurl = 'https://www.research.net/r/RVTHRZN?page_name='+page_name_value+'&page_URL='+ page_URL_value+'&OS='+OS_value+'&Browser='+Browser_value+ '&Language=' +Language_value;		
		
		$('.feedback-button').attr('href', newurl);
			$('.popup-modal').magnificPopup({
				type: 'inline',
				preloader: false,
				focus: '#username',
				modal: true,
				removalDelay: 160,
				closeBtnInside: true,
				fixedContentPos: true,
				mainClass: 'mfp-fade',
				showCloseBtn: true,
				callbacks: {
					elementParse: function(item:any) {
					},
					open: function(item:any) {
						if(window.innerWidth < 768){
							$('.mfp-content').css({ height: '550px' });
						}
						if(window.innerWidth > 768){
							$('.mfp-content').css({ height: '600px' });
						}
						$('.mfp-content').append('<div class="mfp-iframe-scaler"><button title="Close (Esc)" type="button" class="mfp-close">×</button><iframe class="mfp-iframe" src="https://www.research.net/r/RVTHRZN?page_name=Home | Malaysia Airlines" frameborder="0" allowfullscreen=""></iframe></div>');
					},
					close: function(item:any) {

					}
				}
			}
		);
		/*
		$.magnificPopup.instance.st.callbacks = { 
			open: function() {
			}
		}*/

			$('.mfp-pop').magnificPopup({
				disableOn: function () {
					return true;
				},closeBtnInside: true

			});
	}
}
let scope: Element = document.querySelector('.feedback-form--container');
if (scope) {
	try {
		let feedback = new feedbackbutton();
		// feedback.feedurl();
		feedback.popup();
	} catch (e) { console.error(e); }
}